// Badge de shadcn, copiado al repo con los estados de identidad (colors.css)
// sobre base slate: ok para lo que esta en regla, critico para lo que impide
// operar, ambar para lo que avisa, acero para lo asignado o seleccionado y
// neutro para lo informativo. El texto dice el estado; el color lo acompana.
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "./cn.js";

const estilos = cva(
  "inline-flex h-5 items-center gap-1.5 whitespace-nowrap rounded-pill border px-2 text-[11.5px] font-medium leading-none",
  {
    variants: {
      variant: {
        ok: "border-ok/40 bg-ok/10 text-ok-texto",
        critico: "border-critico/40 bg-critico/12 text-critico-texto",
        ambar: "border-ambar/40 bg-ambar/10 text-ambar",
        acero: "border-acero-claro/40 bg-acero/12 text-acero-texto",
        neutro: "border-linea bg-velo text-texto-2",
      },
    },
    defaultVariants: { variant: "neutro" },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof estilos> {}

export function Badge({ className, variant, ...props }: BadgeProps): React.JSX.Element {
  return <span className={cn(estilos({ variant }), className)} {...props} />;
}
